import logoTs from "./logo/logo-ts.png";

export const LogoFull = () => {

  return (
    <img src={logoTs} alt="logo ts" style={{width: 155}} />
  );
};